module.exports = require("web3-provider-engine/subproviders/subscriptions");